import { render } from "./CoBrandVault.vue?vue&type=template&id=3ca671ae&scoped=true"
import script from "./CoBrandVault.vue?vue&type=script&lang=js"
export * from "./CoBrandVault.vue?vue&type=script&lang=js"

import "./CoBrandVault.vue?vue&type=style&index=0&id=3ca671ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca671ae"]])

export default __exports__